module.exports = __webpack_public_path__ + "img/convenio-de-practicas6.e890c57a.png";